import { useCallback, useState } from 'react';
import type { Warranty, WarrantyObjectOption } from '@econtractor/types';
import * as api from 'api/apiWarranties';

const useWarrantyObjectOptions = (productId: number, objectId: number | null, row: Warranty | null) => {
    const [options, setOptions] = useState<WarrantyObjectOption[]>([]);
    const getList = useCallback(
        async ({ search }: { search: string }) => {
            const rows = productId ? await api.objectOptions(productId) : [];
            setOptions(rows);
            const query = search.trim().toLocaleLowerCase();
            return {
                objects: rows.filter((object) =>
                    object.objectName.toLocaleLowerCase().includes(query),
                ),
            };
        },
        [productId],
    );
    const value =
        options.find((object) => object.ID === objectId) ||
        (objectId && row?.objectId === objectId
            ? { ID: objectId, objectName: row.objectName || '', onlySale: false }
            : null);
    return { value, getList };
};

export default useWarrantyObjectOptions;
